export const STYLE_AUTH = {
	title: { m: 1, color: 'text.primary' },
};
